import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledMegaMenuColumn = styled.div`
  min-width: 180px;
  display: flex;
  flex-flow: column;
  flex: 1;
  gap: 8px;
`

const MegaMenuColumn = ({ children }) => {
  return (
    <StyledMegaMenuColumn data-test='megamenu-column'>
      {children}
    </StyledMegaMenuColumn>
  )
}

MegaMenuColumn.propTypes = {
  children: PropTypes.node,
}

export default MegaMenuColumn
